import React, { FC } from 'react';
import Modal from '../../common/Modal/Modal';
import { OTPType } from '../../../hooks/mutates/useOTP';

interface Props {
  type: OTPType;
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalOTPTimeLimit: FC<Props> = ({ type, isShow, onRequestClose }) => {
  return (
    <Modal
      size="fit"
      isShow={isShow}
      isXButton={false}
      title={
        type === `logIn`
          ? `Wallet could not be connected`
          : `Authentication Failed`
      }
      onClose={onRequestClose}
      explanation={
        <>
          The verification code is not valid. <br />
          {type === `logIn`
            ? `You are signed out`
            : `Your wallet will be disconnected`}
          {` `}
          because you have exceeded
          {type === `confirm` && <br />} the verification
          {type === `logIn` && <br />}
          {type === `confirm` && ` `}error limit (5 times). Please try again in
          5 minutes.
        </>
      }
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalOTPTimeLimit;
